import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import CalculatorsPage from "@/pages/CalculatorsPage";
import QuizPage from "@/pages/QuizPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";

function App() {
  useEffect(() => {
    document.title = "Aarkays Consultancy — Build & Protect Your Wealth";
  }, []);

  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/calculators" element={<CalculatorsPage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFAB />
        <Toaster
          position="bottom-right"
          richColors
          toastOptions={{
            style: {
              fontFamily: "'Manrope', sans-serif",
              borderRadius: "12px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
